export const sectionContentType = {
    FIELDS_GROUP: 'fieldsGroup',
    SINGLE_FIELD: 'singleField',
    SUBSECTION: 'subsection'
}